import {useQueryConfig} from '../Utils';
import CompareRepository from '../../../networking/repos/CompareRepository';
import {CompareQueryKey} from './Key';

export const useCompareUniversitiesQueryConfig = (universityIds: number[]) => {
    const repo = new CompareRepository();

    return useQueryConfig(
        CompareQueryKey.universities(universityIds),
        () => repo.compare(universityIds)
    );
};

export const useCompareAccommodationQueryConfig = (universityIds: number[]) => {
    const repo = new CompareRepository();

    return useQueryConfig(
        CompareQueryKey.accommodation(universityIds),
        () => repo.accommodation(universityIds)
    );
};

export const useCompareCostsQueryConfig = (universityIds: number[]) => {
    return useCompareWithPartsQueryConfig('costs', universityIds);
};

export const useCompareFacilitiesQueryConfig = (universityIds: number[]) => {
    return useCompareWithPartsQueryConfig('facilities', universityIds);
};

export const useCompareAcademicProgramQueryConfig = (universityIds: number[]) => {
    return useCompareWithPartsQueryConfig('academic-program', universityIds);
};

const useCompareWithPartsQueryConfig = (part: string, universityIds: number[]) => {
    const repo = new CompareRepository();

    return useQueryConfig(
        CompareQueryKey.parts({ key: part, universityIds }),
        () => repo.compareWithPart(universityIds, part)
    );
};
